import React from 'react'

import { Grid } from '@mui/material'
import debounce from 'lodash/debounce'

import { FormSelect, FormTextField } from 'components/input'
import { withForm } from 'decorators/withForm'

const statusOptions = Object.entries({
  running: 'Running',
  paused: 'Paused',
}).map(([value, label]) => ({ value, label }))

const CampaignTargetsFilters = () => (
  <Grid container spacing={2} style={{ width: 800 }}>
    <Grid size={{ sm: 6 }} />
    <Grid size={{ sm: 3 }}>
      <FormTextField label="Search..." name="query" />
    </Grid>
    <Grid size={{ sm: 3 }}>
      <FormSelect label="Status" name="status" options={statusOptions} />
    </Grid>
  </Grid>
)

// The list filter is local table state; the parent passes onFilterChange and this form pushes debounced changes to it.
export default withForm({
  form: 'campaignTargetsFilters',
  onChange: debounce((values: any, _dispatch: any, props: any) => props.onFilterChange(values), 500),
})(CampaignTargetsFilters)
